import React from 'react'
import styled from 'styled-components'
import BrandLogoIcon from '@ui/icons/BrandLogo'

const Tile = styled.span<{$size: number}>`
  display: inline-grid;
  place-items: center;
  flex: none;
  width: ${({$size}) => $size / 16}rem;
  height: ${({$size}) => $size / 16}rem;
  border-radius: ${({$size}) => Math.round($size * 0.29) / 16}rem;
  background: linear-gradient(
    150deg,
    var(--auth-brand, var(--brand-500)),
    var(--auth-cta, var(--brand-700))
  );
  box-shadow: 0 10px 30px -8px rgba(3, 169, 252, 0.8);
  color: var(--white);

  svg {
    width: 78%;
    height: 78%;
  }
`

export default function StaffologyMark({size = 38}: Readonly<{size?: number}>) {
  return (
    <Tile $size={size} aria-hidden="true">
      <BrandLogoIcon />
    </Tile>
  )
}
